import { cXense, Gemius } from '@analytics/trackers';

interface Params {
  uid: string;
  cxid: string;
  ctx: any;
}

interface EventParams {
  gallery_id: string;
  gallery_image_id: string;
  gallery_image_title?: string;
  gallery_title?: string;
}

export default async function trackPageView(params: Params) {
  const { uid, cxid, ctx } = params;

  if (uid) {
    const gemiusTracker = new Gemius();
    await gemiusTracker.init({ uid });
    gemiusTracker.sendPageEvent();
  }

  if (cxid) {
    const cX = new cXense();
    await cX.init({ uid: cxid });

    const eventParams: EventParams = {
      gallery_id: ctx.galleryId,
      gallery_image_id: ctx.activePicture?.id,
    };

    if (ctx.galleryTitle) {
      eventParams.gallery_title = ctx.galleryTitle;
    }

    if (ctx.activePicture?.metadata?.title) {
      eventParams.gallery_image_title = ctx.activePicture?.metadata?.title;
    }

    const eventOptions = {
      origin: 'lth-delfi',
      persistedQueryId: '60134f11dac530e2cd5c308a42f829d82289a3b8',
    };

    cX.sendEvent('gallery_view', eventParams, eventOptions);
  }
}
